import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import { colors, Typography } from '@sweep-io/sweep-design';
import { ReactNode } from 'react';

interface SectionProps {
  children: ReactNode;
  headerTxt: string;
  withBorderBottom?: boolean;
  sx?: SxProps;
}

export const Section = ({ children, headerTxt, withBorderBottom, sx }: SectionProps) => (
  <Box display="flex" flexDirection="column" gap={1} sx={sx}>
    <Box
      borderBottom={withBorderBottom ? `1px solid ${colors.grey[120]}` : ''}
      pb={withBorderBottom ? 1 : 0}
      pt={withBorderBottom ? 2 : 0}
    >
      <Typography variant="caption-medium">{headerTxt}</Typography>
    </Box>
    {children}
  </Box>
);
